<template>
  <div class="columns-select-group">
    <div class="columns-select-group__header">
      <div class="columns-select-group__dropdown-trigger">
        <DropdownButton
          :value="!(collapsed && !alwaysOpened)"
          @input="triggerCollapse"
        />
      </div>
      <div
        class="columns-select-group__title"
        @click="triggerCollapse"
      >
        <MIcon
          v-if="group.icon"
          class="columns-select-group__icon"
          :icon="group.icon"
        />
        <div class="columns-select-group__group-name">
          {{ groupName }}
        </div>
      </div>
    </div>

    <div
      v-if="!collapsed || alwaysOpened"
      class="columns-select-group__items-list"
    >
      <ColumnsSelectGroupItems
        :selected-items="selectedItems"
        :items="group.children"
        :is-searching="isSearching"
        :child-ids="childIds"
        :enabled-child-ids="enabledChildIds"
        :are-all-children-selected="areAllChildrenSelected"
        :some-children-selected="someChildrenSelected"
        @toggleItems="$emit('toggleItems', $event)"
      />
    </div>
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import arrowIcon from 'assets/icons/bullet-arrow.svg';
  import ColumnsSelectGroupItems
    from 'components/Data/TableSettings/TableSettingsModal/ColumnsSelect/ColumnsSelectGroupItems';
  import DropdownButton from 'components/Inputs/Basic/DropdownButton';

  export default {
    name: 'ColumnsSelectGroup',
    components: {DropdownButton, ColumnsSelectGroupItems, MIcon},
    props: {
      selectedItems: {
        type: Array,
        default: Array
      },
      group: {
        type: Object,
        required: true
      },
      isSearching: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        arrowIcon,
        collapsed: true,
        alwaysOpened: false
      };
    },
    computed: {
      groupName () {
        return this.group.name;
      },
      groupChildren () {
        return this.group.children;
      },

      childIds () {
        return this.groupChildren.map(i => {
          if (i.children) {
            return i.children.map(c => c.id);
          }
          return i.id;
        }).flat();
      },
      enabledChildIds () {
        return this.groupChildren.map(i => {
          if (i.children) {
            return i.children;
          }
          return i;
        }).flat().
          filter(c => !c.disabled).
          map(c => c.id);
      },
      selectedChildItems () {
        return this.childIds.filter(i => this.selectedItems.includes(i));
      },
      areAllChildrenSelected () {
        return this.selectedChildItems.length === this.childIds.length;
      },
      someChildrenSelected () {
        return !this.areAllChildrenSelected && this.selectedChildItems.length > 0;
      }
    },
    mounted () {
      if (this.someChildrenSelected || this.areAllChildrenSelected) {
        this.collapsed = false;
      }
    },
    methods: {
      triggerCollapse () {
        this.collapsed = !this.collapsed;
      }
    }
  };
</script>

<style>
  .columns-select-group {
    --font-color: var(--text-main-color);

    color: var(--font-color);
  }

  .columns-select-group__header {
    font-size: 16px;
    font-weight: var(--medium-font-weight);

    display: flex;

    flex-direction: row;

    margin-top: 15px;
  }

  .columns-select-group__title {
    cursor: pointer;

    display: flex;

    align-items: flex-start;

    user-select: none;
  }

  .columns-select-group__icon {
    flex-grow: 0;
    flex-shrink: 0;

    width: 16px;
    height: 16px;

    margin-right: 4px;
  }

  .columns-select-group__group-name {
    text-overflow: ellipsis;

    overflow: hidden;

    /* webkit-box not working in firefox, but in this case it is ok, it will not break layout */
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */

    /* stylelint-disable property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* stylelint-enable property-no-vendor-prefix */
  }

  .columns-select-group__items-list {
    margin-left: 8px;
  }

  /* apply style for second and next elements */
  .columns-select-group__items-list > .columns-select-group-list__item ~ .columns-select-group-list__item {
    margin-top: 12px;
  }

  .columns-select-group__dropdown-trigger {
    flex-grow: 0;
    flex-shrink: 0;

    margin-right: 4px;
  }

</style>
